import { doc, getDoc } from 'firebase/firestore';

import { db } from '../services/firebase.js';

const CACHE = new Map();
const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes

/**
 * Service to fetch Chapter Location Data
 */
export const ChapterLocationService = {
    /**
     * Fetch locations for a specific level and chapter.
     * Path: feature_testing/Korea_University/ChapterLocations/{level}_{chapter}
     * 
     * @param {string|number} level 
     * @param {string|number} chapter 
     * @returns {Promise<Object>} The chapter config with locations
     */
    getChapterLocations: async (level, chapter) => {
        const docId = `level_${level}_chapter_${chapter}`;

        // Check Cache
        if (CACHE.has(docId)) {
            const { data, timestamp } = CACHE.get(docId);
            if (Date.now() - timestamp < CACHE_DURATION) {
                console.log(`[ChapterLocationService] Cache Hit for ${docId}`);
                return data;
            }
        }

        try {
            const docRef = doc(db, 'feature_testing/Korea_University/ChapterLocations', docId);
            const docSnap = await getDoc(docRef);

            if (docSnap.exists()) {
                const data = docSnap.data();

                // Sort locations by order just in case
                if (data.locations && Array.isArray(data.locations)) {
                    data.locations.sort((a, b) => a.order - b.order);
                }

                // Update Cache
                CACHE.set(docId, { data, timestamp: Date.now() });
                return data;
            } else {
                console.warn(`[ChapterLocationService] Document ${docId} not found.`);
                return null; // Handle this in UI (loading or empty state)
            }
        } catch (error) {
            console.error(`[ChapterLocationService] Error fetching ${docId}:`, error);
            throw error;
        }
    },

    /**
     * Clear cache (useful for admin actions)
     */
    clearCache: () => {
        CACHE.clear();
    }
};
